var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.success)?_c('sui-message',{attrs:{"success":"","content":_vm.success,"dismissable":""},on:{"dismiss":function($event){return _vm.setSuccess(false)}}}):_vm._e(),(_vm.error)?_c('sui-message',{attrs:{"error":"","content":_vm.error,"dismissable":""},on:{"dismiss":function($event){return _vm.setError(false)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }